import { createAction } from 'redux-actions';

export const FORM_SUBMIT = 'FORM_SUBMIT';

export default createAction(FORM_SUBMIT);
